enum EWidgetDataFormat {
  MONEY = 'money',
  PERCENTAGE = 'percentage',
  QUANTITY = 'quantity',
  PERIOD = 'period',
  CURRENCY = 'currency',
}

export default EWidgetDataFormat;
